import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  company: Cookies.get('company'),
  snackbar_message: null,
  pagination: null
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  company: state => state.company,
  check: state => state.user !== null,
  snackbar_message: state => state.snackbar_message,
  pagination: state => state.pagination
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN] (state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  [types.FETCH_USER_SUCCESS] (state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE] (state) {
    state.token = null
    Cookies.remove('token')
  },

  [types.LOGOUT] (state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
  },

  [types.UPDATE_USER] (state, { user }) {
    state.user = user
  },
  saveCompany (state, { company }) {
    state.company = company
    Cookies.set('company', company, { expires: 365 })
  },
  saveSnackbarMessage (state, { message }) {
    state.snackbar_message = message
  },
  savePagination (state, { pagination }) {
    state.pagination = pagination
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },
  saveCompany ({ commit, dispatch }, payload) {
    commit('company', payload)
    Cookies.set('company', payload, { expires: 365 })
  },
  savePagination ({ commit, dispatch }, payload) {
    commit('pagination', payload)
  },
  saveSnackbarMessage ({ commit, dispatch }, payload) {
    commit('snackbar_message', payload)
  },
  async fetchUser ({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout ({ commit }) {
    try {
      await axios.post('/api/logout')
      localStorage.removeItem('crmToken')
    } catch (e) {
    }

    commit(types.LOGOUT)
  },

  async fetchOauthUrl (ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)

    return data.url
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js